import { useThree } from '@react-three/fiber';

const ControlsWrapper = ({ target }) => {
	const { controls } = useThree();
	if (controls) {
		controls.target.set(...target);
	}
	return null;
};

export default ControlsWrapper;
